import { useEffect, useRef } from 'react'
import { SDrawerOrModal, SGeneralForms } from 'shj-components'
import { Button, message, Select, Spin } from 'antd'
import { useSetState } from 'ahooks'
import {
  startWork,
  verifyOuterData,
  startMerchOverflow,
  orderDetail,
  startBpmFlow, findBuildingInfoForOrderResponseByRequest,
} from '@/services/order'
import dayjs from 'dayjs'
import { getRealEstateList } from '@/services/homeService'
interface IProps {
  title: string
  orderId: string
  open: boolean
  detailsInfo: Record<string, any>
  setOpen: (open: boolean) => void
}
export default function ChangeAddress(prpos: IProps) {
  const formRef = useRef(null)
  const { open, title, setOpen, orderId, detailsInfo } = prpos
  const [state, setState] = useSetState<any>({
    loading: false,
    errInfo: [],
    btnLoading: false,
    estateList: [],
    oldBuilding: {},
  })

  useEffect(() => {
    console.log('open---->', open, detailsInfo)
    if (open) {
      // 获取订单详情信息
      setState({ loading: true })
      orderDetail(orderId)
        .then((res: any) => {
          setState({ oldBuilding: res || {} })
          onFormRef()?.setFieldsValue({
            oldBuildingPlace: `${res?.buildingName || ''}  ${res?.houseNumber || ''}`,
          })
        })
        .finally(() => {
          setState({ loading: false })
        })
    }
  }, [open])

  const onFormRef = () => {
    const { onFormRef } = formRef.current || {}
    return onFormRef?.()
  }

  const onsubmit = () => {
    onFormRef()
      ?.validateFields()
      .then(values => {
        setState({ btnLoading: true })
        console.log(values)
        let moreInfo = getMoreInfo(values.newBuildingId)
        console.log(moreInfo)
        let submitObj = {
          orderId: orderId,
          oldBuildingId: state.oldBuilding.id,
          oldBuildingName: state.oldBuilding.buildingName,
          oldHouseNumber: state.oldBuilding.houseNumber,
          newHouseNumber: values.newHouseNumber,
          newBuildingId: values.newBuildingId,
          newBuildingName: moreInfo.name,
          newProvinceName: moreInfo.provinceName,
          newCityName: moreInfo.cityName,
          newCountyName: moreInfo.countyName,
        }
        startBpmFlow({ data: submitObj })
          .then(res => {
            message.success('提交成功')
            onCancel()
          })
          .finally(() => {
            setState({ btnLoading: false })
          })
      })
  }
  const getMoreInfo = id => {
    return state.estateList.find(item => item.id === id)
  }
  const onCancel = () => {
    onFormRef()?.resetFields()
    setOpen(false)
  }

  const getOptions = async () => {
    const estateList: any = await findBuildingInfoForOrderResponseByRequest({orderId})

    setState({ estateList: estateList.buildingInfoList || [] })
    return Promise.resolve({ estateList: estateList.buildingInfoList || [] })
  }
  return (
    <SDrawerOrModal
      title={title}
      mode="modal"
      open={open}
      width={500}
      onCancel={onCancel}
      antdProps={{
        footer: (
          <div>
            <Button onClick={onCancel}>取消</Button>
            {/* disabled={state.errInfo.length} */}
            <Button
              style={{ marginLeft: 15 }}
              loading={state.btnLoading}
              type="primary"
              onClick={onsubmit}
            >
              提交
            </Button>
          </div>
        ),
      }}
    >
      {open && (
        <div>
          <Spin spinning={state.loading}>
            <div>
              <SGeneralForms
                ref={formRef}
                httpOptionsFn={getOptions}
                layout={'vertical'}
                configs={[
                  {
                    formItem: [
                      {
                        spanCol: 24,
                        label: '原楼盘地址',
                        name: 'oldBuildingPlace',
                        comConfig: {
                          disabled: true,
                        },
                      },
                      {
                        label: '新楼盘地址',
                        name: 'newBuildingId',
                        spanCol: 24,
                        required: true,
                        children: (
                          <Select
                            placeholder={'请选择楼盘'}
                            showSearch
                            optionFilterProp="name"
                            fieldNames={{ label: 'name', value: 'id' }}
                            options={state.estateList}
                          />
                        ),
                      },
                      {
                        spanCol: 24,
                        label: '新房号',
                        name: 'newHouseNumber',
                        required: true,
                      },
                    ],
                  },
                ]}
              />
            </div>
          </Spin>
        </div>
      )}
    </SDrawerOrModal>
  )
}
